import {FC, useEffect, useState} from "react";
import doneImg from '../../../assets/nps/images/Group.png';
import css from './NpsThanks.module.scss';
import NpsHead from "../NpsHead";
import HeaderLogo from "../../../components/HeaderLogo";
import {useLocation, useNavigate} from "react-router-dom";
import Button from "../../../elements/Button/Button";

interface NpsThanksProps {
    title?: string;
    description?: string;
    headTitle?: string;
    buttonTitle?: string;
    linkTitle?: string;
    countryCode?: string;
}

const NpsThanks: FC<NpsThanksProps> = (props) => {
    const {
        title = '',
        description = '',
        headTitle = '',
        buttonTitle = '',
        linkTitle = '',
    } = props;
    const locationState = useLocation().state as NpsThanksProps;
    const navigate = useNavigate();
    const [locationCountryCode, setLocationCountryCode] = useState('ua');
    useEffect(() => {
        setLocationCountryCode(locationState.countryCode || 'ua');
    }, [])

    if (!(locationState?.title || title) && !(locationState?.description || description)) {
        return (
            <div className={css.wrapper}>
                <NpsHead title={locationState.headTitle || headTitle}/>
                <HeaderLogo/>
                <h1 className={css.notFound}>Page not found</h1>
            </div>
        )
    }

    return (
        <div className={css.wrapper}>
            <NpsHead title={locationState.headTitle || headTitle}/>
            <HeaderLogo className={css.headerLogo}/>
            <main className={css.main}>
                <div className={css.doneLogo}>
                    <img className={css.doneLogo__img} alt={'done'} src={doneImg}/>
                </div>
                <div className={css.gratitude}>
                    <h2 className={css.gratitude__title}>
                        {locationState.title || title}
                    </h2>
                    <p className={css.gratitude__description}>
                        {locationState.description || description}
                    </p>
                </div>
                <Button className={css.btn}
                        href={`https://${locationCountryCode}.jooble.org/employer/employerpage`}>
                    {locationState.buttonTitle || buttonTitle}
                </Button>
            </main>
            <footer className={css.footer}>
                <a className={css.footer__moreResponse}
                   onClick={() => navigate(-1)}> {locationState.linkTitle || linkTitle}</a>
            </footer>
        </div>
    )
}

export default NpsThanks;